import { FC } from 'react';

import { OnboardingStatus as OnboardingStatusType } from 'api/types/entity';
import { OnboardingStatus } from 'modules/onboarding/common/components';
import { OnboardingSuccessStatusFeature } from 'modules/onboarding/common/feature/ClientOnboardingStatusFeature/OnboardingSuccessStatusFeature';

type Props = {
  onboardingStatus: OnboardingStatusType;
};

export const LegalClientOnboardingStatusFeature: FC<Props> = ({
  onboardingStatus,
}) => {
  if (onboardingStatus === 'success') {
    return <OnboardingSuccessStatusFeature />;
  }

  return <OnboardingStatus onboardingStatus={onboardingStatus} />;
};
